module.exports = __webpack_public_path__ + "src/assets/img/earbuds_03.e7fc618b.png";